export enum ValidationTypeEnum {
  email = 'email',
  numbers = 'numbers',
  empty = 'empty',
  required = 'required',
  nationalID = 'nationalID',
  insuranceLevel = 'insuranceLevel',
  default = 'default'
}
